<template>
	<div class="grid md:grid-cols-2 gap-4">
		<div
			v-for="(section, index) in sections"
			:key="index"
			class="flex flex-col gap-y-4 items-center">
			<touch-button
				v-for="button in section.items"
				:key="button.text"
				:links="button.links"
				:icon="button.icon"
				:transforms="button.transforms"
				:theme="section.theme"
				:label="button.text"
				:area="button.area"
				:show-count="button.showCount">
				{{ button.text }}
			</touch-button>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'
	import useAuthStore from '@/stores/auth'

	interface touchButton {
		text: string
		links: object[]
		icon: string
		transforms?: string
		disabled?: boolean
		area?: string
		showCount?: boolean
	}

	const authStore = useAuthStore()

	const goodsOut = <touchButton[]>[
		// {
		// 	text: 'Stock Check',
		// 	links: [
		// 		{
		// 			url: '/yard-app/stock-items'
		// 		}
		// 	],
		// 	icon: 'fa-clipboard-check',
		// 	area: 'stock-check'
		// },
		{
			text: 'Stock Check Requests',
			links: [
				{
					url: '/stock/stock-check-requests'
				}
			],
			icon: 'fa-list',
			area: 'stock-check',
			showCount: true
		},
		{
			text: 'Pick Items',
			links: [
				{
					url: '/yard-app/pick-items'
				}
			],
			icon: 'fa-hand',
			area: 'pick'
		},
		{
			text: 'Load',
			links: [
				{
					url: '/yard-app/load-items'
				}
			],
			icon: 'fa-truck',
			area: 'load-delivery'
		},
		{
			text: 'Stock Take',
			links: [
				{
					url: '/stocktake-app'
				}
			],
			icon: 'fa-clipboard',
			area: 'stock-take',
			showCount: false
		}
	]

	const visibleGoodsOut = computed(() => {
		return goodsOut.filter((item) => {
			if (item.text === 'Stock Check Requests') {
				return authStore.isAbleTo(['view-stock-check-requests'])
			}

			return true
		})
	})

	const goodsIn = <touchButton[]>[
		{
			text: 'Collection',
			links: [
				{
					url: '/yard-app/collection-items'
				}
			],
			icon: 'fa-truck',
			transforms: 'fa-flip-horizontal',
			area: 'collections'
		}
	]

	const sections = computed(() => [
		{ items: visibleGoodsOut.value, theme: 'primary' },
		{ items: goodsIn, theme: 'secondary' }
	])
</script>
